export default __webpack_public_path__ + "f02f2c9c1cbeb9e6afdba30bbb0603e3.png";